var map = {
	"./adult/de/1 0 Orddiktat Intro.mp3": 729,
	"./adult/nn/1 0 Orddiktat Intro.mp3": 730,
	"./adult/no/1 0 Orddiktat Intro.mp3": 731,
	"./youth/de/1 0 Orddiktat Intro.mp3": 732,
	"./youth/nn/1 0 Orddiktat Intro.mp3": 733,
	"./youth/no/1 0 Orddiktat Intro.mp3": 734,
	"./youth/se/1 0 Orddiktat Intro.mp3": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 728;